module.exports = __webpack_public_path__ + "media/talent/Moms-Sneha-b03018cc.png";